var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"modal-stuff"},[_c('h5',[_vm._v("Stats")]),_c('hr'),_c('pre',[_vm._v(_vm._s(_vm.stats))]),_c('hr'),_c('div',{staticClass:"modal-menu"},[_c('button',{staticClass:"btn btn-danger",on:{"click":function($event){_vm.showStatsModal = false}}},[_vm._v("Close")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }